export const SKIPPED_SECTIONS = {
  DYSFUNCTIONS_SECTIONS: 'DYSFUNCTIONS_SECTIONS',
  MEDICAL_BACKGROUND_SECTION: 'MEDICAL_BACKGROUND_SECTION'
};
